<div *ngIf="idiomaDisplay$ | async as idiomaDisplay" class="header-mainInfo">
  <span class="barra-txt-responsive"><strong>Retroalimentación / </strong>{{unidad.nombre}}</span>
  <span class="spacer"></span>
  <div>
    <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
      {{idiomaDisplay}}
    </button>
    <mat-menu #menu="matMenu">
      <div *ngIf="idiomas$ | async as idiomas">
        <button *ngFor="let idioma of idiomas" (click)="cambiarIdioma(idioma.value)" mat-menu-item>
          {{idioma.value | i18nSelect: {'es': 'Español', 'en': 'English', 'fr': 'Français', 'de': 'Deutsche' } }}
        </button>
      </div>
    </mat-menu>
  </div>
</div>
